import React from "react";

export const leafCircleOutline = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
      <circle
        cx="12"
        cy="12"
        r="11.2"
        stroke="currentColor"
        strokeWidth="1.6"
      />
      <path
        fill="currentColor"
        d="M14.982 6.788c-1.298-1.364-2.592-2.076-2.646-2.106L12 4.5l-.336.182c-.054.03-1.348.742-2.646 2.106-1.744 1.833-2.666 3.983-2.666 6.217A5.655 5.655 0 0 0 12 18.653a5.655 5.655 0 0 0 5.648-5.648c0-2.234-.922-4.384-2.666-6.217m-3.685 6.719-3.234-2.518a7.5 7.5 0 0 1 .88-1.856l2.354 1.834zm1.406-2.54 2.351-1.831c.357.552.666 1.17.88 1.855l-3.231 2.516zM14.2 8.018l-1.498 1.167V6.623c.445.344.98.811 1.498 1.395m-2.904-1.395v2.562l-1.5-1.168a10.6 10.6 0 0 1 1.5-1.394m-3.54 6.382q0-.232.016-.46l3.524 2.743v1.901a4.25 4.25 0 0 1-3.54-4.184m4.946 4.184v-1.9l3.523-2.744q.016.226.017.46a4.25 4.25 0 0 1-3.54 4.184"
      />
    </svg>
  );
};
